<!-- HORMONAL IMPRINT: hero -->
<div class="card hi-hero-card" style="margin-bottom:10px;padding:16px 18px 14px;">
  <div style="display:flex;align-items:baseline;gap:7px;margin-bottom:4px;">
    <div style="font-size:15px;font-weight:800;color:var(--navy);letter-spacing:-0.2px;">{{ 'results.hi.title' | translate }}</div>
  </div>
  <div style="font-size:10px;color:var(--g400);margin-bottom:10px;">{{ 'results.hi.subtitle' | translate }}</div>

  <!-- wordfirst sec 2: evaluation WORD + 3-level bar (the score itself moves into
       the reveal below). No ring, no visible number on the panel screen. -->
  <app-band-scale [band]="vm.band" [config]="bandConfig" [score]="vm.score" [aboutKey]="'results.about.imprint'"></app-band-scale>

  <div class="hi-hero-copy" style="margin-top:13px;">
    <p style="font-size:13px;font-weight:700;color:var(--navy);line-height:1.45;margin:0;">{{ vm.heroCopy1Key | translate }}</p>
    <p style="font-size:12px;color:var(--g600);line-height:1.65;margin:0;">{{ 'results.hi.heroCopy2' | translate }}</p>
  </div>

  <div style="font-size:11px;color:var(--g500);line-height:1.5;margin:2px 0 0;padding-top:10px;border-top:1px solid var(--g100);">{{ 'results.hi.disclaimer' | translate }}</div>

  <details class="reveal" *ngIf="vm.score !== null">
    <summary>
      <svg class="rev-chev" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><polyline points="6 9 12 15 18 9"/></svg>
      {{ 'results.reveal.numbersBehind' | translate }}
    </summary>
    <div class="rev-body">
      <div class="numrow">
        <div class="bignum">{{ vm.score }}<span>/100</span></div>
        <div style="flex:1;min-width:0;">
          <span class="dir-chip">{{ 'results.hi.lowerBetter' | translate }}</span>
          <p>{{ 'results.reveal.scoreNote' | translate }}</p>
        </div>
      </div>

      <!-- comparison bar, flipped: green at the RIGHT, avg = thin line + label below -->
      <div class="cmp-flip" *ngIf="vm.comparison.hasAvg">
        <div class="cmp-head">{{ vm.comparison.headKey | translate }}</div>
        <div class="cmp-track">
          <div class="cmp-avg" [style.left.%]="100 - vm.comparison.avgValue"><span class="cmp-avg-tag">{{ 'results.reveal.avg' | translate }}</span></div>
          <div class="cmp-you" [style.left.%]="100 - vm.comparison.youValue"><span class="cmp-you-tag">{{ 'results.reveal.you' | translate: { n: vm.score } }}</span></div>
        </div>
        <div class="cmp-ends"><span>{{ vm.comparison.endKey | translate }}</span><span>{{ vm.comparison.startKey | translate }}</span></div>
        <p class="cmp-note">{{ 'results.reveal.cmpNote' | translate }}</p>
      </div>
    </div>
  </details>
</div>

<!-- PROGRESS OVER TIME (#22) -->
<app-progress-card [vm]="progress" (goPaywall)="goPaywall.emit()"></app-progress-card>

<!-- FACE-ANALYSIS CARD (#21): before skin condition + eye area (Danna 13.10) -->
<app-face-analysis-card [vm]="vm.faceAnalysis"></app-face-analysis-card>

<!-- PRIMARY ZONES -->
<div class="hi-primary-grid">
  <ng-container *ngFor="let z of [vm.skinZone, vm.eyeZone]">
    <div class="ia-zone-card hi-zone-card" style="padding:0;display:flex;overflow:hidden;border-radius:4px 12px 12px 4px;box-sizing:border-box;">
      <div style="width:3px;flex-shrink:0;" [style.background]="z.accent"></div>
      <div style="padding:12px 11px;flex:1;">
        <div style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;margin-bottom:6px;" [style.color]="z.accentText">{{ z.eyebrowKey | translate }}</div>
        <div style="display:inline-block;padding:2px 8px;border-radius:999px;font-size:10px;font-weight:700;margin-bottom:8px;" [style.background]="z.status.bg" [style.color]="z.status.color">{{ z.status.labelKey | translate }}</div>
        <div style="display:flex;flex-direction:column;gap:5px;">
          <div *ngFor="let r of z.rows" style="display:flex;justify-content:space-between;align-items:center;">
            <span style="font-size:10px;color:var(--g500);">{{ r.labelKey | translate }}</span>
            <span style="font-size:10px;font-weight:700;" [style.color]="r.sev.color">{{ r.sev.labelKey | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- DEEP DIVE -->
<details class="hi-accordion" style="margin-bottom:14px;">
  <summary class="ia-deep-toggle">
    {{ 'results.hi.deepToggle' | translate }}
    <svg class="ia-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg>
  </summary>

  <div class="hi-details-grid" style="margin-top:10px;margin-bottom:10px;">
    <div class="card hi-connector-card" style="padding:8px 12px;box-sizing:border-box;">
      <div style="display:inline-flex;align-items:center;gap:5px;background:#ede8fb;border-radius:999px;padding:3px 9px 3px 7px;margin-bottom:5px;">
        <span style="width:4px;height:4px;border-radius:50%;background:#7c5cbf;flex-shrink:0;"></span>
        <span style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#7c5cbf;">{{ 'results.hi.connector.eyebrow' | translate }}</span>
      </div>
      <p style="font-size:11px;font-weight:500;color:var(--navy);line-height:1.55;margin:0;">{{ 'results.hi.connector.body' | translate }}</p>
    </div>
  </div>

  <!-- Skin score breakdown -->
  <div class="card skin-score-card" style="margin-top:10px;margin-bottom:10px;">
    <div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-bottom:12px;">
      <h3 class="section-title" style="margin-bottom:0;">{{ 'results.hi.skinScore.title' | translate }}</h3>
      <span style="font-size:10px;font-weight:600;color:#888;background:#f3f1ee;border:1px solid #e7e3dd;border-radius:999px;padding:2px 10px;white-space:nowrap;">{{ 'results.hi.skinScore.higherBetter' | translate }}</span>
    </div>


    <div class="ia-score-row" *ngFor="let m of vm.skinMetrics">
      <div style="flex:1;min-width:0;"><div style="font-size:13px;font-weight:600;color:var(--navy);">{{ m.labelKey | translate }}</div></div>
      <div class="ia-bar-track"><div class="ia-bar-fill" [style.width.%]="m.score" [style.background]="m.color"></div></div>
      <div class="ia-average-value" *ngIf="m.avg != null">{{ 'results.hi.avg' | translate }}<strong>{{ m.avg }}</strong></div>
    </div>

    <!-- Region breakdowns -->
    <div style="border-top:1px solid var(--g100);margin-top:16px;padding-top:14px;">
      <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;color:var(--g400);margin-bottom:10px;">{{ 'results.hi.glossByZone' | translate }}</div>
      <div style="display:flex;flex-direction:column;gap:5px;margin-bottom:14px;">
        <div *ngFor="let r of vm.oiliness" style="display:flex;justify-content:space-between;align-items:baseline;">
          <span style="font-size:12px;color:var(--g600);">{{ r.labelKey | translate }}</span>
          <span style="font-size:12px;font-weight:700;" [style.color]="r.color">{{ r.valueKey | translate }}</span>
        </div>
      </div>
      <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;color:var(--g400);margin-bottom:8px;">{{ 'results.hi.drynessByZone' | translate }}</div>
      <div style="display:flex;flex-direction:column;gap:4px;margin-bottom:14px;">
        <div *ngFor="let r of vm.dryness" style="display:flex;justify-content:space-between;"><span style="font-size:12px;color:var(--g600);">{{ r.labelKey | translate }}</span><span style="font-size:12px;font-weight:700;" [style.color]="r.color">{{ r.valueKey | translate }}</span></div>
      </div>
      <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;color:var(--g400);margin-bottom:8px;">{{ 'results.hi.poresByZone' | translate }}</div>
      <div style="display:flex;flex-direction:column;gap:4px;">
        <div *ngFor="let r of vm.pores" style="display:flex;justify-content:space-between;"><span style="font-size:12px;color:var(--g600);">{{ r.labelKey | translate }}</span><span style="font-size:12px;font-weight:700;" [style.color]="r.color">{{ r.valueKey | translate }}</span></div>
      </div>
    </div>

    <div style="display:flex;gap:7px;background:#f3f7f9;border-radius:10px;padding:10px 12px;margin-top:14px;">
      <span style="width:4px;background:var(--accent);border-radius:999px;flex-shrink:0;align-self:stretch;"></span>
      <p style="font-size:12px;color:var(--navy);line-height:1.6;margin:0;" [innerHTML]="'results.hi.skinNote' | translate"></p>
    </div>
  </div>

  <!-- Eye zone detail -->
  <div class="card" style="margin-bottom:10px;">
    <h3 class="section-title">{{ 'results.hi.eyeDetail.title' | translate }}</h3>
    <div *ngFor="let e of vm.eyeDetail; let last = last" [style.border-bottom]="last ? null : '1px solid var(--g100)'" [style.padding-bottom]="last ? '4px' : '12px'" style="margin-bottom:12px;">
      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:5px;">
        <div style="font-size:13px;font-weight:700;color:var(--navy);">{{ e.titleKey | translate }}</div>
        <span style="padding:3px 9px;border-radius:999px;font-size:10px;font-weight:700;" [style.background]="e.sevBg" [style.color]="e.sevColor">{{ e.sevKey | translate }}</span>
      </div>
      <p style="font-size:12px;color:var(--g400);line-height:1.6;margin:0;" *ngIf="e.descKey">{{ e.descKey | translate }}</p>
    </div>
    <p style="font-size:12px;color:var(--g400);line-height:1.65;margin:12px 0 0;padding-top:12px;border-top:1px solid var(--g100);">{{ 'results.hi.eyeNote' | translate }}</p>
  </div>

  <!-- Wrinkle zone map -->
  <div class="card" style="margin-bottom:10px;">
    <h3 class="section-title">{{ 'results.hi.wrinkleMap.title' | translate }}</h3>
    <p style="font-size:12px;color:var(--g400);line-height:1.5;margin-bottom:12px;">{{ 'results.hi.wrinkleMap.desc' | translate }}</p>
    <div class="ia-zone-map">
      <div class="ia-zone-map-item" *ngFor="let z of vm.wrinkleZones">
        <div style="font-size:11px;font-weight:600;color:var(--g600);margin-bottom:2px;">{{ z.labelKey | translate }}</div>
        <div style="font-size:9px;color:var(--g400);margin-bottom:5px;">{{ z.descKey | translate }}</div>
        <div style="height:4px;background:var(--g100);border-radius:2px;overflow:hidden;margin-bottom:6px;"><div style="height:4px;border-radius:2px;" [style.width.%]="z.pct" [style.background]="z.color"></div></div>
        <div style="display:inline-block;padding:2px 9px;border-radius:999px;font-size:10px;font-weight:700;" [style.background]="z.color==='#1fa864' ? '#edfff5' : z.color==='#f59d00' ? '#fff4e0' : '#fff0e6'" [style.color]="z.color==='#1fa864' ? '#1a7a4a' : z.color==='#f59d00' ? '#b37400' : '#bf4800'">{{ z.sevKey | translate }}</div>
      </div>
    </div>

    <div style="border-top:1px solid var(--g100);margin-top:14px;padding-top:14px;">
      <div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;color:var(--g400);margin-bottom:8px;">{{ 'results.hi.scoreBasis.title' | translate }}</div>
      <p style="font-size:12px;color:var(--g500);line-height:1.6;margin:0 0 10px;">{{ 'results.hi.scoreBasis.p1' | translate }}</p>
      <p style="font-size:12px;color:var(--g500);line-height:1.6;margin:0;">{{ 'results.hi.scoreBasis.p2' | translate }}</p>
    </div>
  </div>
</details>
